import React, { useState, useEffect, useRef } from "react";
import ReportsExpand from "../common/ReportsExpand";
import Select from "../common/Select";

function BulkSurveys({ divisions, isFavorite, toggleFavorite, ...rest }) {
  const [reportData, setReportData] = useState({ Division: "" });
  const isMountedRef = useRef(true);
  const reportOrg =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "SOARLive"
      : "SOARD365Base";

  useEffect(() => {
    return () => (isMountedRef.current = false);
  }, []);

  const handleChange = ({ currentTarget: input }) => {
    const data = { ...reportData };
    data[input.name] = input.value;
    setReportData(data);
  };

  const openReport = () => {
    console.log("Report Org: ", process.env.REACT_APP_ENVIRONMENT);
    const url = `https://safyreports.azurewebsites.net/Reports/BulkSurveys/F223F222A?db=${reportOrg}&d=${reportData.Division}`;
    window.open(url, "Bulk Surveys");
  };

  return (
    <ReportsExpand
      title="F223 & F22A Bulk Surveys"
      isFavorite={isFavorite}
      toggleFavorite={toggleFavorite}
      {...rest}
    >
      <div className="row">
        <Select
          className="col-3"
          name="Division"
          label="Division"
          options={divisions}
          onChange={handleChange}
        />
        <div className="col-7"></div>
        {reportData.Division !== "" && (
          <i
            className="fas fa-arrow-circle-right fa-3x col col-2 float-end"
            onClick={openReport}
          ></i>
        )}
      </div>
    </ReportsExpand>
  );
}

export default BulkSurveys;
